import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useNavigate } from 'react-router-dom';
import { useCustomer } from '../../contexts/CustomerContext';

const InventoryTab = ({ 
  inventory, 
  searchQuery 
}) => {
  const navigate = useNavigate();
  const { getEffectiveCustomerId } = useCustomer();

  const toTitleCase = (str) => {
    return str.replace(
      /\w\S*/g,
      (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
  };

  const handleCategoryClick = (category) => {
    const customerId = getEffectiveCustomerId();
    if (customerId) {
      // Navigate to inventory page with categoryId parameter to open the category details
      navigate(`/app/${customerId}/inventory?categoryId=${category.parentEqpId}`);
    }
  };

  if (inventory.length === 0) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <Icon icon="material-symbols:search-off" className="text-6xl text-bgAccent mb-4" />
          <p className="text-font-secondary text-lg">No inventory found for "{searchQuery}"</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 w-full min-h-0 overflow-hidden">
      {/* Inventory Categories List */}
      <div className="flex flex-col w-full transition-all duration-300 ease-out overflow-hidden">
        <div className="w-full h-full flex flex-col">
          {/* Categories List - Matching main Inventory.jsx styling */}
          <div className="flex-1 overflow-y-auto scrollable rounded-lg card-container p-0 bg-background">
            {inventory.map((category, index) => (
              <div 
                key={category.parentEqpId || `category_${index}`}
                className="w-full flex flex-row justify-between items-center px-4 py-3 border-b border-bgAccent hover:rounded-md hover:border-transparent hover:bg-bgSecondary hover:button-container cursor-pointer transition-all ease-out-in duration-300"
                onClick={() => handleCategoryClick(category)}
              >
                <div className="w-full flex flex-col gap-2">
                  {/* Category Header */}
                  <div className="flex items-center gap-2">
                    <Icon icon="duo-icons:box-2" className={`text-4xl ${
                      category._hasPendingChanges ? 'text-orange-500' :
                      category._isPendingCreation ? 'text-primary opacity-100' :
                      'text-accent opacity-30'
                    }`} />
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-font-primary capitalize">
                        {category.parentCategory || 'Unnamed Category'}
                      </h3>
                      <div className="text-sm text-font-secondary">
                        {category.childItems?.length || 0} items
                        {category._hasPendingChanges && (
                          <span className="text-orange-600"> • Modified by {category._changedBy}</span>
                        )}
                        {category._isPendingCreation && (
                          <span className="text-blue-600"> • Created by {category._changedBy}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="typical-uses-responsive flex flex-row items-center gap-2 w-full">
                    <p className="text-sm text-font-primary">Typical Uses:</p>
                    <div className="flex flex-wrap gap-1">
                      {category.typicalUses?.split(',').slice(0, 3).map((use, useIndex) => (
                        <span key={`${category.parentEqpId}_use_${useIndex}`} className="text-xs text-font-primary p-1.5 rounded-md tag-gray">
                          {toTitleCase(use.trim())}
                        </span>
                      ))}
                      {category.typicalUses?.split(',').length > 3 && (
                        <span className="text-sm text-font-secondary px-2 mt-2 rounded-md">
                          <span className="text-primary font-bold">+{category.typicalUses.split(',').length - 3}</span> more
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <Icon icon="mdi:chevron-right" className="text-3xl text-primary" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryTab;
